<template>
    <div class="d-flex mb-10">
      <div class="p-5 d-flex align-items-start fs-5" @click="showPublish" style="border-radius: 5px; width: 100%; background-color: #f5f8fa;" v-if="!publish">
        {{ $t('projects.publish_text') }}...
      </div>
      <div class="p-5" v-else style="width: 100%; background-color: #f5f8fa;">
        <form @submit.prevent="addComment">
          <div class="d-flex justify-content-end mb-5">
            <i class="fas fa-times" @click="showPublish"></i>
          </div>
          <div class="mb-5">
            <div class="d-flex mb-3">
              <div
                  class="card d-flex gap-3 flex-row align-items-center shadow rounded-2 p-2">
                <i v-for="(reaction, index) in reactionEnum"
                   @click.prevent="makeReact(reaction.value)"
                   :key="index"
                   class="fa cursor-pointer hovering-zoom"
                   v-html="reaction.value"
                   style="font-size: 1.2rem"
                ></i>
              </div>
            </div>
            <CKEditor @text="writeText" :content="content" id="comment-editor" ktClass="h-50px" :with-image="false"/>
          </div>
          <div class="d-flex justify-content-end">
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.send" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </form>
      </div>
    </div>
   
    <div v-for="comment in comments" :key="comment?.id" class="back d-flex justify-content-between align-items-center mb-5">
       <div class="d-flex align-items-center">
            <div class="symbol symbol-50px symbol-circle">
                <div class="symbol-label bg-white fs-2 fw-bold text-primary">{{ initialName(comment?.full_name) ?? 'A' }}</div>
            </div>
            <div class="mx-4  align-items-center">
                <h5>{{comment?.full_name ?? 'Anonyme'}}</h5>
                <div class="mb-0" v-html="comment?.comment"></div>
            </div>
       </div>
       <div class="d-flex align-items-center">
            <p class="mb-0 mx-4 ">{{ format(comment.created_at) }}</p>
            <button class="btn btn-icon btn-ligth" @click="removeComment(comment?.id)">
                <i class="fas fa-times text-danger fs-4 me-2"></i>
            </button>
       </div>
    </div>

</template>
<script setup>
import { useSwal } from '@/composables/useSwal';
import { computed, onMounted } from 'vue';
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import CKEditor from "@/components/CKEditor.vue";
import Button from "@/components/Button";
import {formatDistance} from "date-fns";
import {fr} from "date-fns/locale";

const props = defineProps({
    data: {type: Array, default: []}
})

const store = useStore()
const route = useRoute()
const {showSwal} = useSwal()

const publish = ref(false)
const comment = ref("")
const isLoading = ref(false)
const nowDate = ref(new Date())
const setIntervalId = ref(null)

const reactionEnum = computed(() => store.getters['projects/getProjectReactionEnum'])
const comments = computed(() => store.getters['comments/getComments'])

onMounted(() => {
  store.dispatch('projects/loadProjectReactionEnum')
  setIntervalId.value = setInterval(() => {
    nowDate.value = new Date()
  }, 1000)

})

function format(date){
  return formatDistance(new Date(date), nowDate.value, { locale: fr})
}

function showPublish(){
  publish.value = !publish.value
}

function writeText(text) {
  comment.value = text
}

function initialName(name) {
  let username = name.split(' ')
  return username[0].charAt(0) + username[1].charAt(0)
}

const addComment = async () => {
  isLoading.value = true
  try{
    await store.dispatch('comments/createTaskComment', {content: comment.value, task_id: route.params.id})      
    store.dispatch('comments/loadTaskComments', route.params.id)
    publish.value = false
    comment.value = ""
  }catch(err){

  }finally{
    isLoading.value = false
  }
}

function makeReact(comment) {
  store.dispatch('comments/createTaskComment', {content: comment, task_id: route.params.id})
      .then(res => {})
      .catch(() => {})
      .finally(() => {})
}

const removeComment = (id) => {
  showSwal(
      i18n.global.t('swal.comment'),
      i18n.global.t('swal.comment_text')
  ).then( async (result) => {
    if (result.value) {
      try{
        await store.dispatch('comments/deleteTaskComment', id)      
        store.dispatch('comments/loadTaskComments', route.params.id)
      }catch(err){

      }
    }
  });
}


</script>
<style>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 10px;
  width: auto;
}


</style>